import React from 'react'
import Reflux from 'reflux'
import Store from '../../store/store'
import {Link} from 'react-router-dom'
import Field from '../common/Field'
import Validator from '../common/Validator'
import api from '../../source/api'
import Alert from '../common/alert'
import User from '../../helpers/user'

class Login extends Reflux.Component {

    constructor(props) {
        super(props);
        this.state = {
            fields: {
                email: {value: '', error: '', role: {required: true}},
                password: {value: '', error: '', role: {required: true}},
            },
            loginFeedback: {
                type: '',
                message: ''
            },
            error: false,
            loading: false,
            success: ''
        };
        this.store = Store
    }

    setValue = (name, value, error) => {
        this.resetErrorMessage();
        let fields = this.state.fields;
        fields[name].value = value;
        fields[name].error = error;
        this.setState({fields: fields})
    };

    loginUser = () => {
        let validator = Validator.validate(this.state.fields);
        this.setState({
            fields: validator.fields,
            error: validator.error
        })

        if (this.state.error) {
            return;
        }

        let data = {
            email: this.state.fields.email.value,
            password: this.state.fields.password.value
        };

        this.resetErrorMessage();
        api.post('auth/login', data)
            .then((response) => {
                User.login(response.data);
            })
            .catch((error) => {
                if (error.response && error.response.status === 422) {
                    this.setErrorMessage(error.response.data.message);
                    return;
                }

                this.setErrorMessage('Hiba történt a bejelentkezés során');
            })
    }

    setErrorMessage = (message) => {
        this.setState({
            loginFeedback: {
                type: 'danger',
                message: message
            }
        });
    }

    resetErrorMessage = () => {
        this.setState({
            loginFeedback: {
                type: '',
                message: ''
            }
        });
    };

    render() {
        return (
            <div className='container'>
                <div className="site-login">
                    <h1 className="offset-md-4 col-lg-4 text-center">Bejelentkezés</h1>
                    <p className="offset-md-4 col-lg-4 text-center">Kérjük adja meg Belépési adatait:</p>
                    <div className="row">
                        <div className="col-lg-4 offset-md-4">
                            {this.state.loginFeedback.type.length > 0 ? <Alert type={this.state.loginFeedback.type} message={this.state.loginFeedback.message}/> : ''}
                        </div>
                        <div className="col-lg-4 offset-md-4">
                            <Field
                                type="email"
                                id="login-email"
                                name="email"
                                label="Email cím"
                                classLabel="control-label"
                                classInput="form-control"
                                setValue={this.setValue.bind(this)}
                                state={this.state}
                                style={{width: '100%'}}
                            />
                            <Field
                                type="password"
                                id="login-password"
                                name="password"
                                label="Jelszó"
                                classLabel="control-label"
                                classInput="form-control"
                                setValue={this.setValue.bind(this)}
                                state={this.state}
                                style={{width: '100%'}}
                            />
                            <div>
                                Ha elfelejtette a jelszavát <Link to="/request-password-reset">ide kattintva</Link> kérhet újat.
                            </div>
                            <div className="form-group  text-center">
                                <br/>
                                <button type="submit" onClick={() => this.loginUser()} className="btn green-btn" name="login-button">Bejelentkezés</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default Login


// WEBPACK FOOTER //
// ./src/components/login/login.js